import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PILLARS } from "../data/pillars";
import { MockPanel } from "./MockPanel";

const ProductCard = ({ pillar }) => {
    const navigate = useNavigate();
    return (
        <button
            data-testid={`product-card-${pillar.id}`}
            onClick={() => navigate(`/services#${pillar.id}`)}
            className="group relative text-left w-full h-full flex flex-col focus:outline-none focus-visible:ring-2 focus-visible:ring-neon rounded-2xl"
        >
            <MockPanel pillar={pillar} className="flex-1" fullTitle />
            <span className="absolute top-6 right-16 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 text-neon">
                <ArrowUpRight size={18} strokeWidth={2.25} />
            </span>
            <span className="mt-4 inline-flex items-center gap-1.5 font-mono text-xs tracking-[-0.01em] text-black/50 group-hover:text-neon transition-colors">
                Explore service
                <ArrowUpRight
                    size={14}
                    className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                />
            </span>
        </button>
    );
};

export const ProductGrid = () => (
    <section
        id="products"
        data-testid="products-section"
        className="relative py-24 sm:py-32"
    >
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
            <div className="max-w-2xl mb-14 sm:mb-20">
                <span className="font-mono text-xs tracking-[-0.01em] text-black/50">
                    // OUR PRODUCTS
                </span>
                <h2 className="font-mono tracking-[-0.01em] text-3xl sm:text-4xl font-semibold text-black mt-3">
                    Five engines. One operation.
                </h2>
                <p className="font-body text-base sm:text-lg text-black/60 mt-4">
                    Areas where tailored AI and optimisation boost efficiency —
                    click any engine to explore the service in detail.
                </p>
            </div>

            <div className="flex flex-wrap justify-center gap-6 sm:gap-7 items-stretch">
                {PILLARS.map((p) => (
                    <div
                        key={p.id}
                        className="w-full sm:w-[calc(50%-0.875rem)] lg:w-[calc(33.333%-1.167rem)] flex"
                    >
                        <ProductCard pillar={p} />
                    </div>
                ))}
            </div>
        </div>
    </section>
);
